import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";
import { Boundaries } from "@planzone/core";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  reasons: [],
};

function handleRequest(state: State): State {
  return {
    ...state,
    request: setRequestStateToPending(),
  };
}
function handleSuccess(
  state: State,
  reasons: Boundaries["retrieveUnavailabilityReasons"]["success"],
): State {
  return {
    ...state,
    request: setRequestStateToSuccess(),
    reasons,
  };
}
function handleFailure(state: State): State {
  return {
    ...state,
    request: setRequestStateToFailure(),
  };
}
const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.retrieveUnavailabilityReasonsRequested]: handleRequest,
    [events.retrieveUnavailabilityReasonsSucceeded]: handleSuccess,
    [events.retrieveUnavailabilityReasonsFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
